import { useCallback, useEffect, useMemo } from "react";
import { modules } from "byzantine";
import { useCurrentUser } from "../../../contexts/CurrentUserContext";

const useDisableDeliveryChannels = (alertKey: API.AlertKey) => {
  const { currentUser } = useCurrentUser();
  const disableDeliveryChannels =
    modules.alerts.useDisableDeliveryChannels(alertKey);

  const hasPhone = Boolean(currentUser?.phone?.number);

  const disabledChannels = useMemo((): API.DeliveryChannel[] => {
    const channels: API.DeliveryChannel[] = ["push" as API.DeliveryChannel];
    if (!hasPhone) {
      channels.push("sms" as API.DeliveryChannel);
    }
    return channels;
  }, [hasPhone]);

  const updateDeliveryChannels = useCallback(() => {
    disableDeliveryChannels(disabledChannels);
  }, [disableDeliveryChannels, disabledChannels]);

  useEffect(() => {
    updateDeliveryChannels();
  }, []);
};

export default useDisableDeliveryChannels;
